const validDomains = [
  'http://localhost:4688',
  'https://dotnetwebsite-dev.int-dot.net',
  'https://dotnetwebsite-staging.int-dot.net',
  'https://dotnetwebsite.int-dot.net',
  'https://dotnetwebsite-dev.azurewebsites.net',
  'https://dotnetwebsite-staging.azurewebsites.net',
  'https://dotnetwebsite.azurewebsites.net',
  'https://dotnet.microsoft.com',
];

export default validDomains;
